var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_916_7978",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.99292,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_916_7978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "calendar_today",
    d: "M3.75 17.4929C3.3375 17.4929 2.98425 17.3462 2.69025 17.0527C2.39675 16.7587 2.25 16.4054 2.25 15.9929V5.49292C2.25 5.08042 2.39675 4.72742 2.69025 4.43392C2.98425 4.13992 3.3375 3.99292 3.75 3.99292H4.5V2.49292H6V3.99292H12V2.49292H13.5V3.99292H14.25C14.6625 3.99292 15.0158 4.13992 15.3098 4.43392C15.6033 4.72742 15.75 5.08042 15.75 5.49292V15.9929C15.75 16.4054 15.6033 16.7587 15.3098 17.0527C15.0158 17.3462 14.6625 17.4929 14.25 17.4929H3.75ZM3.75 15.9929H14.25V8.49292H3.75V15.9929Z",
    fill: "#F6F6F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.2a0cc89ec5110f87be450a56ddda058f.svg";
export { ForwardRef as ReactComponent };